import React, { Component } from "react";
import compose from "recompose/compose";
import Card from "@material-ui/core/Card";
import Error from "@material-ui/icons/Error";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CardIcon from "./CardIcon";
import LinearProgress from "@material-ui/core/LinearProgress";
import dataProviderFactory from "../../dataProvider";
import { GET_LIST } from "react-admin";
import VehiclesPopover from "../vehiclesPopover";
import Info from "@material-ui/icons/Info";
import * as R from "ramda";
import styled from "styled-components";
import Button from '@material-ui/core/Button';
import CachedIcon from '@material-ui/icons/Cached';
import Grid from '@material-ui/core/Grid';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const styles = {
  main: {
    flex: "1",
    marginLeft: "1em",
    marginTop: 20
  },
  card: {
    overflow: "inherit",
    textAlign: "right",
    padding: 16,
    minHeight: 52
  }
};

class DisplacedVehiclesWarning extends Component {
  async fetchDisplacedBikes(forcedReload= false) {
    const dataProvider = await dataProviderFactory("rest");
    let filters = {
      filter: {},
      pagination: {
        page: 1,
        perPage: 5000
      },
      sort: {}
    }
    if(forcedReload){
      filters.filter = {forcedReload:true}
    }
    const response = await dataProvider(GET_LIST, "displaced_vehicles", filters);
    return response.data;
  }
    handleForcedReload = async () => {
    this.setState({
      loading: true
    })
    const displacedData = await this.fetchDisplacedBikes(true); 
    this.setState({
      displacedVehicles: displacedData
    });
    this.setState({ loading: false })
  }

  async componentDidMount() {
    const displacedData = await this.fetchDisplacedBikes(); 
     for (let index = 0; index < displacedData.length; index++) {
       const element = displacedData[index];
       let otrer = String(element.licence_plate)
       const resp =  'OTHER'
       let posicion = otrer.indexOf(resp);
       if ( posicion > -1)
       {
        displacedData.splice(index , 1); 
       }
     } 
    this.setState({
      displacedVehicles: displacedData
    });
  }

  render() {
    const { classes } = this.props;
    if (this.state === null || this.state.loading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }


    const displacedBikes = () => {
      const { displacedVehicles } = this.state;
      const data = R.filter(
        R.where({
          displaced: displaced => displaced === true
        })
      )(displacedVehicles);
      return data;
    };
    return (
      <div className={classes.main}>
        <Card className={classes.card}>
        <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <CardIcon Icon={Error} bgColor="#fc7d19" />
            </Grid>
            <Grid item>
            
              <Typography className={classes.title} color="textSecondary">
                Vehicles out of place:
              </Typography>
              <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
              >
                <Grid item >
                  <StyledDiv>
                    <Typography variant="subtitle1" component="h2">
                      {R.length(displacedBikes())}
                    </Typography>
                    <VehiclesPopover
                      itemText="Displaced Bikes"
                      items={displacedBikes()}
                      iconImage={Info}
                    />
                </StyledDiv>
                </Grid>
                <Grid item >
                  <Button onClick={this.handleForcedReload}><CachedIcon /></Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
            </Card>
      </div>
    );
  }
}

const enhance = compose(withStyles(styles));
export default enhance(DisplacedVehiclesWarning);



// WEBPACK FOOTER //
// ./src/components/dashboard/DisplacedVehiclesWarnings.js